import React from 'react';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import sampleImage1 from '../assets/images/projects/eugene-gasanze/1.jpg';
import sampleImage2 from '../assets/images/projects/eugene-kanombe/2.jpg';
import sampleImage3 from '../assets/images/projects/birembo/3.jpg';

const testimonials = [
  {
    name: "Jane Doe",
    designation: "Home Owner",
    company: "Private Client",
    testimonial: "The EDGES team transformed our ideas into a stunning design.",
    projectDescription: "A modern two-story residential home designed for sustainability and style.",
    projectImage: sampleImage1,
  },
  {
    name: "John Smith",
    designation: "Developer",
    company: "Urban Build Co.",
    testimonial: "They truly brought our vision to life with professionalism and style.",
    projectDescription: "An eco-friendly apartment complex with modern amenities.",
    projectImage: sampleImage2,
  },
  {
    name: "Linda Kim",
    designation: "Architect",
    company: "DesignFlow Ltd.",
    testimonial: "Professional, punctual, and extremely creative.",
    projectDescription: "Minimalist residential project designed for efficiency and comfort.",
    projectImage: sampleImage3,
  },
];

function Testimonial() {
  return (
    <>
    <section
      id="testimonials"
      className="py-20 px-6 bg-gradient-to-r from-teal-800 to-teal-500 text-white relative"
    >
      <div className="text-center mb-16">
        <h2 className="text-2xl md:text-3xl font-bold text-white">
          - What <span className="text-teal-200">Our</span> Clients Say -
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto">
        {testimonials.map((item, index) => (
          <div key={index} className="relative pt-10">
            {/* Floating Quote Icon */}
            <div className="absolute -top-0 left-6 bg-white p-4 rounded-full shadow-lg z-10">
              <FaQuoteLeft className="text-teal-700 text-xl" />
            </div>

            {/* Testimonial Card */}
            <div className="bg-white text-gray-800 rounded-2xl shadow-md overflow-hidden px-6 pb-6 pt-6 flex flex-col h-full">
              <img
                src={item.projectImage}
                alt={item.name}
                className="h-48 w-full object-cover rounded-lg mb-4"
              />
              <h1 className="text-xl font-bold mb-1">{item.name}</h1>
              <p className="text-sm italic text-gray-500 mb-3">{item.projectDescription}</p>
              <p className="text-base mb-4 flex-grow">{item.testimonial}</p>

              <div className="flex text-yellow-400 mb-2">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} className="mr-1" />
                ))}
              </div>
              <p className="text-sm text-gray-600">
                {item.designation} - {item.company}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
    </>
  );
}

export default Testimonial;



